import { actionCreator } from '@ardoq/rxbeach';
import type { AiControlledCommandId } from './aiControlledCommandId';

export const aiControlledCommandApplied = actionCreator<AiControlledCommandId>(
  '[aiControlledCommands] COMMAND_APPLIED'
);
